<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col vs-type="flex" vs-w="6">
        <div
          v-if="printerSettings"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">Yazıcı Ayarı</span>
          </div>
          <form data-vv-scope="form-pos-ip-settings">
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
              <vs-col vs-w="6">
                <span class="weight-600">Durum :</span>
                <vs-switch class="ml-2" v-model="printerSettings.enable">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> API Url (http://192.168.8.118) </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}$/,
                }"
                name="API URL"
                placeholder="API URL"
                v-model="printerSettings.apiUrl"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                errors.first("form-pos-ip-settings.API URL")
              }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600"> Kasa Yazıcı Adı </span>
              <vs-input
                name="Kasa Yazıcı Adı"
                placeholder="Kasa Yazıcı Adı"
                v-model="printerSettings.mainPrinterName"
                class="w-full"
              />
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-pos-ip-settings.API URL')"
                color="success"
                @click="submitPrinterSettings"
                >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
import { setPrinterSetting, getPrinterSetting } from "@/api/PrinterSetting";
export default {
  name: "PrinterSettings",
  data() {
    return {
      printerSettings: {
        apiUrl: "",
        enable: false,
        branchId: null,
        id: null,
        mainPrinterName: "",
      },
    };
  },
  methods: {
    submitPrinterSettings: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let branchId = userInfo.branch.id;
      await getPrinterSetting(branchId);
      let checker;
      checker = await this.$validator.validateAll("form-pos-ip-settings");
      if (checker) {
        setPrinterSetting(this.printerSettings)
          .then((res) => {
            if (res && res.status === 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Printer Ayarları Güncellendi !",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Printer Ayarları Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    getPrinterSetting() {
      getPrinterSetting()
        .then((res) => {
          if (res && res.status === 200) {
            this.printerSettings = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Printer Ayarları Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
  },
  created: async function () {
    await this.getPrinterSetting();
  },
};
</script>
<style></style>
